import apiConfig from '../../../shared/config/apiConfig'
import { createBrandApiRequest } from '../../../shared/brand/utils/brandApiUtils'
import {
  mapBrandSearchResponse,
  mapUserSearchResponse,
} from '../mappers/brandLookupMapper'

const MINIMUM_QUERY_LENGTH = 3

const normalizeBrandResponse = (response = {}) => {
  if (!response || Array.isArray(response) || typeof response !== 'object') {
    return response
  }

  return {
    ...response,
    brand_category_id: response.brand_category_id || response.brandCategoryId,
    brand_category_name:
      response.brand_category_name || response.brandCategoryName,
    slug: response.slug,
    brand_id: response.brand_id || response.brandId,
    brand_name: response.brand_name || response.brandName,
    brand_type: response.brand_type || response.brandType,
  }
}

export const createBrandSetupService = ({ axiosInstance } = {}) => {
  const { apiKey = '', brandAPIs = {} } = apiConfig
  const { BRAND_SEARCH, BRANDS, USER_SEARCH } = brandAPIs
  const request = createBrandApiRequest({ apiKey, axiosInstance })

  return {
    createBrand: async (payload) =>
      normalizeBrandResponse(
        await request({ body: payload, endpoint: BRANDS, method: 'post' }),
      ),
    updateBrand: async (brandUuid, payload) =>
      normalizeBrandResponse(
        await request({
          body: payload,
          endpoint: `${BRANDS}/${encodeURIComponent(brandUuid)}`,
          method: 'patch',
        }),
      ),
    searchBrands: async (query = '') => {
      const normalizedQuery = query.trim()
      if (normalizedQuery.length < MINIMUM_QUERY_LENGTH) return []

      const response = await request({
        endpoint: BRAND_SEARCH,
        queryParams: {
          query: normalizedQuery,
          queryCondition: 'BEGINS',
        },
      })
      return mapBrandSearchResponse(response)
    },
    searchUsers: async (query = '') => {
      const normalizedQuery = query.trim()
      if (normalizedQuery.length < MINIMUM_QUERY_LENGTH) return []

      const response = await request({
        endpoint: USER_SEARCH,
        queryParams: { id: normalizedQuery },
      })
      return mapUserSearchResponse(response)
    },
  }
}

export const brandSetupService = createBrandSetupService()
